export const convertDateToDateString = (dateString: string) => {
  if (dateString === ""){
    return ""
  }
  const date = new Date(dateString);

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const dayName = days[date.getDay()];
  const day = date.getDate();
  const monthName = months[date.getMonth()];

  const formattedDate = `${dayName} ${day} ${monthName}`;
  return formattedDate
}